<!-- Title -->
<h1 mat-dialog-title>
  Save Module
</h1>

<!-- Content -->
<div mat-dialog-content class="theme-light">
  <form [formGroup]="form" (submit)="handleSubmit()">
    <!-- Duplicate States -->
    <app-form-field>
      <mat-checkbox formControlName="duplicateStates"><span class="text-12">Duplicate Content States</span></mat-checkbox>
      
      <div form-field-help>
        This requires that you specify the location for the new module, and new unused names for each of the content states.
      </div>
    </app-form-field>
    
    <!-- Trim Graph -->
    <app-form-field>
      <mat-checkbox formControlName="trimGraph"><span class="text-12">Trim Graph</span></mat-checkbox>
    </app-form-field>

    <mat-divider class="mb-4"></mat-divider>

    <!-- Primary Category -->
    <app-form-field label="Primary Category">
      <select class="input" formControlName="primaryCategory">
        <option *ngFor="let category of (primaryCategoryOptions$ | async)" [value]="category">{{ category }}</option>
      </select>
    </app-form-field>

    <!-- Secondary Category, can be empty -->
    <app-form-field label="Secondary Category" *ngIf="(secondaryCategoryOptions$ | async)?.length">
      <select formControlName="secondaryCategory" class="input">
        <option *ngFor="let category of (secondaryCategoryOptions$ | async)" [value]="category">{{ category }}</option>
      </select>
    </app-form-field>

    <!-- Name -->
    <app-form-field label="Name">
      <input type="text" class="input w-100" formControlName="name" #name>
      
      <div class="pt-2 text-12" *ngIf="modulePath && name.value.length">
        <!-- Module Exists -->
        <div class="text-info" *ngIf="moduleExists && !(formDuplicateStates.value)">
          <fa-icon icon="exclamation-triangle"></fa-icon> 
          <span class="pl-2">{{modulePath}}</span>
          <span class="pl-2 text-bold">(File exists)</span>
        </div>

        <!-- Module Exists AND cannot be overwritten -->
        <div class="text-danger" *ngIf="moduleExists && (formDuplicateStates.value)">
          <fa-icon icon="exclamation-circle"></fa-icon> 
          <span class="pl-2">{{modulePath}}</span>
          <span class="pl-2 text-bold">(File exists and cannot be overwritten)</span>
        </div>

        <!-- New Module -->
        <div class="text-success" *ngIf="!moduleExists">
          <fa-icon icon="check-circle"></fa-icon>
          <span class="pl-2">{{modulePath}}</span>
        </div>
      </div>
    </app-form-field>

    <!-- Confirm Production -->
    <app-form-field label="Production Save" *ngIf="formPrimaryCategory.value === 'production'">
      <mat-checkbox formControlName="confirmProduction"><span class="text-12">I intend to save to Production</span></mat-checkbox>
    </app-form-field>

    <!-- Duplicate States -->
    <div *ngIf="formDuplicateStates.value">
      <mat-divider class="mv-4"></mat-divider>
        
      <!-- Prefix -->
      <app-form-field label="Prefix">
        <div class="flex">
          <input type="text" class="input flex-25 w-25" #prefix pattern="[^ ]*">

          <button type="button" app-button buttonType="outline" class="ml-2" buttonTheme="light" (click)="handleReplaceClick(prefix.value)">Replace</button>
          <button type="button" app-button buttonType="outline" class="ml-2" buttonTheme="light" (click)="handlePrependClick(prefix.value)">Prepend</button>
        </div>

        <div class="pv-4 text-12" formArrayName="states">

          <!-- State group -->
          <div *ngFor="let state of formStates.controls; let i=index" class="mb-2">
            <div [formGroupName]="i">
              <div class="flex">
                <!-- Enable -->
                <div class="flex-shrink pr-2 pt-2">
                  <mat-checkbox formControlName="include" matTooltip="Include State"></mat-checkbox>
                </div>

                <!-- State Name -->
                <div class="flex-grow">
                  <input type="hidden" class="input" formControlName="oldState">
                  <input type="text" class="input" formControlName="newState">
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-form-field>
    </div>
  </form>

</div>
      
<!-- Actions -->
<div mat-dialog-actions>
  <button app-button buttonTheme="light" [mat-dialog-close] type="button" class="mr-2">Cancel</button>

  <button
    app-button
    buttonTheme="light"
    buttonType="primary"
    [disabled]="(saving$ | async) || !form.valid || validating"
    (click)="handleSubmit()">
      <!-- Validating -->
      <ng-container *ngIf="validating">
        <app-spinner size="medium" class="ml-2" render="inline"></app-spinner>
        Validating
      </ng-container>

      <!-- Saving -->
      <ng-container *ngIf="(saving$ | async)">
        <app-spinner size="medium" class="ml-2" render="inline"></app-spinner>
        Saving
      </ng-container>

      <!-- Save -->
      <ng-container *ngIf="!validating && !(saving$ | async)">
        Save Module
      </ng-container>
  </button>
</div>